import { DocumentViewer as DocumentViewerComponent } from "../../components/ui/document-viewer/document-viewer";
import { useFile } from "../../queries/documents/use-file";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { QueryError } from "@/components/ui/query-error/query-error";
import { Loader } from "lucide-react";

export interface DocumentViewerProps {
  fileId: string;
  title: string;
}

export const DocumentViewer = forwardRef(
  (
    { fileId, title }: DocumentViewerProps,
    ref: React.Ref<HTMLIFrameElement>
  ) => {
    const { t } = useTranslation();

    const {
      fileUrl,
      isPending,
      error: fileError,
      refetch: refetchFile,
    } = useFile(fileId);

    if (fileError) {
      const retries = [fileError && refetchFile];

      return (
        <QueryError
          resource={t("documentViewer.document")}
          errors={[fileError]}
          retries={retries}
        />
      );
    }

    return (
      <>
        {isPending && (
          <div className="h-full w-full flex justify-center items-center">
            <Loader
              className="h-24 w-24 text-gray-500 animate-spin"
              data-testid="loader"
            />
          </div>
        )}
        {fileUrl && (
          <DocumentViewerComponent ref={ref} url={fileUrl} name={title} />
        )}
      </>
    );
  }
);
